<template>
    <div class="pb-5">
      <nav-bar/>
      <!-- <sidebar-toggle-button/> -->
      <div class="filter-button-group">
        <div class="d-flex justify-content-center align-items-center">
        <toggle-button-group
            :buttons="orderFilterOptions" 
            :activeButton="selectedOrderFilter" 
            :handleClick="handleFilterButtonClick" 
        />
        <div class="toggle-button-group">
          <button
              :key="'verifyButton'"
              :class="{ active: selectedOrderFilter === 'verify' }"
              @click="handleToggle('verify')"
          >
              {{ this.$t('OrderCurrent.sidebar.toVerify') }}
          </button>
        </div>
          </div>
      </div>

      <table-element
        :isShowFilter="true"
        :title="$t('ToVerify.title')"
        :fields="fieldsObj"
        :arrOfElement="delivered"
        :sortSpacing="2"
        class="card mx-2 mt-2"
      >
      <template #header-actions>
        <div class="header-actions">
          <!-- <button :disabled="!hasFullAccess || selected.length < 1" @click="openStatusEdit();" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.quick_status')}}</button> -->
        </div>
      </template>
  
        <template #body-content-desktop="content">
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="order['.key']"
        :class="{
          'cancel': order.status === 'to cancel',
          'dispatch': order.status === 'to finish'
          }">
          <!-- <td class="pt-2">
              <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
                <input :value="order['.key']" v-model="selected" type="checkbox" class="custom-control-input"> 
                <span class="custom-control-indicator" :class="{'uncheck': !selected.includes(order['.key']), 'check': selected.includes(order['.key'])}"></span>
              </label>
            </td> -->
          <td class="pt-2">
            <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
              <input type="button" class="btn btn-kne-orange" :value="$t('OrderCurrent.view')">
            </router-link>
          </td>
          <td v-if="!isDateRoute" class="pt-2">
            <a :href="order.invoice" target="_blank" @click="print(order)">
              <!-- <input type="button" class="btn btn-kne-orange pull-right" :value="$t('OrderCurrent.view')"> -->
              <button class="btn btn-kne-orange" :class="{'printed': order.isPrinted}">
              <!-- <button class="btn btn-kne-orange pull-right" :class="{'printed': !order.isPrinted}"> -->
                <i class="fa fa-print" aria-hidden="true" />
              </button>
            </a>
          </td>
          <td class="pt-2">
            <button class="btn btn-kne-orange" @click="generateDocuments(order)">
                <i class="fas fa-sync" aria-hidden="true" />
            </button>
          </td>
          <td class="nowrap pt-3">{{order['.key']}}
            <!-- <span v-if="unlistedOrderKeys.includes(order['.key'])" class="text-warning mr-1">
              <i class="fas fa-exclamation-triangle"></i> 
            </span> -->
            <hover-tool-tip
              :text="`<div>
                        ${order.source || '-'}
                        <br>${getDate(order.creationDate) || '-'}
                        <br>${order.make || '-'} ${order.model || '-'} ${order.year || '-'}
                      </div>`"
              :top="true"
              :right="true"
              clickable
            />
          </td>
          <!-- <td v-if="hasIntegration" class="nowrap">
            <i v-if="order.isDivisionX" class="fa fa-check" aria-hidden="true" />
          </td> -->
          <!-- <td class="nowrap pt-3">{{order.numRef || '-'}}</td> -->
          <!-- <td class="nowrap"><p class="table-fix-width">{{order.source}}</p></td> -->
          <td class="nowrap pt-3">{{order.vin || '-'}}</td>
          <!-- <td class="nowrap">{{ getDate(order.creationDate) }}</td> -->
          <td class="nowrap pt-3">
            <div v-if="order.historySync && ['Dispatch', 'Pick', 'Transit', 'Drop'].includes(order.status)">
                <!-- <div>{{shortenString(lastHistorySync(order.historySync, 'transmitterName')) || '-'}} -->
                  <div>{{shortenString($realName(order, 'transmitter')) || '-'}}
                  <hover-tool-tip
                    :text="`<p>${lastHistorySync(order.historySync, 'transmitterAddress') || '-'} ${lastHistorySync(order.historySync, 'transmitterCity') || '-'}
                              <br>${lastHistorySync(order.historySync, 'transmitterProvince') || '-'} ${lastHistorySync(order.historySync, 'transmitterPostcode') || '-'}, ${lastHistorySync(order.historySync, 'transmitterCountry') || '-'}
                            </p>`"
                    :left="true"
                    :top="true"
                    clickable
                  /> 
                </div>
                <!-- <div class="fw-700">({{ lastHistorySync(order.historySync, 'transmitterZone') || '-' }})</div> -->
                <div class="fw-700">({{ order.transmitterZone || '-' }})</div>
              </div>
              <div v-if="!order.historySync || !['Dispatch', 'Pick', 'Transit', 'Drop'].includes(order.status)">
                <div>{{ shortenString($realName(order, 'transmitter')) || '-'}}
                  <hover-tool-tip
                    :text="`<p>${order.transmitterAddress || '-'} ${order.transmitterCity || '-'}
                              <br>${order.transmitterProvince || '-'} ${order.transmitterPostcode || '-'}, ${order.transmitterCountry || '-'}
                            </p>`"
                    :left="true"
                    :top="true"
                    clickable
                  /> </div>
                <div v-if="order.transmitterZone" class="fw-700">({{order.transmitterZone}})</div>
              </div>
          </td>
          <td class="nowrap pt-3">
              <div v-if="order.historySync && ['Dispatch', 'Pick', 'Transit', 'Drop'].includes(order.status)">
                <!-- <div>{{shortenString(lastHistorySync(order.historySync, 'receiverName')) || '-'}} -->
                  <div>{{shortenString($realName(order, 'receiver')) || '-'}}
                  <hover-tool-tip
                    :text="`<p>${order.receiverAddress || '-'} ${order.receiverCity || '-'}
                              <br>${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                            </p>`"
                    :left="true"
                    :top="true"
                    clickable
                  />
                </div>
                <div class="fw-700">({{ order.receiverZone || '-' }})</div>
              </div>
              <div v-if="!order.historySync || !['Dispatch', 'Pick', 'Transit', 'Drop'].includes(order.status)">
                <div>{{ shortenString($realName(order, 'receiver'))|| '-'}}
                  <hover-tool-tip
                    :text="`<p>${order.receiverAddress || '-'} ${order.receiverCity || '-'}
                              <br>${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                            </p>`"
                    :left="true"
                    :top="true"
                    clickable
                  /> </div>
                <div v-if="order.receiverZone" class="fw-700">({{order.receiverZone}})</div>
              </div>
          </td>
          <td class="nowrap pt-3">
            <p class="table-fix-width">{{ shortenString($realName(order, 'payer')) || '-' }}</p>
          </td>
          <td class="nowrap pt-3">
            <span v-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
            <span v-if="order.status === 'to cancel'">To Cancel</span>
            <span v-if="order.status === 'to finish'">To Finish</span>
          </td>
          <!-- <td class="nowrap pt-3"><p class="table-fix-width">{{order.driverName || '-'}}</p></td> -->
          <td>
            <div class="pull-right mr-2" id="action">
              <button class="btn btn-kne-orange" @click="approveAction(order)">
                <i class="fa fa-check" aria-hidden="true" />
              </button>
              <button class="ml-2 btn btn-kne-orange" @click.once="denyAction(order)">
                <i class="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </td>
        </tr>
      </template>
  
        <template #body-content-mobile="content">
          <!-- List of orders -->
          <transition-group name="fade">
            <div class="card my-3 mx-2" v-for="order in content.results" :key="order['.key']">
              <div class="card-header m-2">
                <h4>{{order.source || '-'}}</h4>
                <h6><i class="fa fa-calendar mr-1" /> {{ getDate(order.creationDate) || '-'}}</h6>
              </div>
              <div class="m-2">
                <p><i class="fa fa-asterisk" /> {{order.numRef || '-'}}</p>
                <p><i class="fa fa-car" /> {{order.vin || '-'}}</p>
                <p><i class="fa fa-home" /> {{$realName(order, 'transmitter') || '-'}}</p>
                <p><i class="fa fa-truck" /> {{$realName(order, 'receiver') || '-'}}</p>
                <p><i class="fa fa-credit-card" /> {{$realName(order, 'payer') || '-'}}</p>
              </div>
            </div>
          </transition-group>
        </template>
      </table-element>
  
      <loading-render v-if="isLoading" />

      <status-change-modal
        v-if="isStatusEdit"
        ref="shortDispatchModal"
        :arrOfOrder="selectedFull"
        :isOpen="isStatusEdit"
        :priceOrderLink="priceOrderLink"
        :toDeny="true"
        @closeModal="isStatusEdit = false; clearSelected()"
        @clearSelected="clearSelected"
      />
    </div>
  </template>
  
  <script>
  import Modal from '../module/interface-components/Modal.vue'
  import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
  import regularInput from '../module/basic-components/regularInput.vue'
  import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import Search from '../module/special-components/Other-components/Search.vue'
  import StatusChangeModal from '../module/special-components/Modal-templates/StatusChange-modal.vue'
  import {db} from '../../firebase'
  // import _ from 'lodash'
  import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
  import regularInputNumber from '../module/basic-components/regularInputNumber.vue'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
  import ToggleSwitch from '../module/special-components/Other-components/ToggleSwitch.vue'
  import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'
  import { publishOrderSyncRequest } from '../../odoo-sync-requests/order'
  import { isRegularOrder } from '@/inventory/inventorySelectors'

  export default {
    name: 'orderDelivered',
    components: {
      Modal,
      regularInput,
      regularCheckbox,
      regularTextarea,
      regularInputNumber,
      regularDatalistDriver,
      Search,
      SidebarToggleButton,
      regularSelect,
      TableElement,
      LoadingRender,
      ToggleSwitch,
      hoverToolTip,
      ToggleButtonGroup,
      StatusChangeModal
    },
  
    data () {
      return {
        deliverySave: false,
        allDeliveries: [],
        VIN: '',
        MAKE: '',
        MODEL: '',
        YEAR: '',
        SIZE: '',
        selected: [],
        vehicles: [],
        user: {
          name: '',
          address: '',
          city: '',
          zipCode: '',
          province: '',
          phone: '',
          nir: '',
          cigle: '',
          logo: ''
        },
        pricingAndDelay: [],
        priceOrderLink: [], // This is to create a price/order link list for dispatches
        pickupSave: false,
        inProgress: '',
        filterResults: [],
        spreadDate: '',
        selectedOrder: {},
        searchHistory: [],
        selectedFull: [],
        selectedFull2: [],
        searchType: '',
        searchText: '',
        historyTypeTag: '',
        sizeTooltipText: '',
        isOdooBill: false,
        priceTooltipText: '',
        sizeTooltipColor: '',
        priceTooltipColor: '',
        isEditOrderModal: false,
        billing: false,
        isStatusEdit: false,
        vinPrinting: false,
        quickEdit: false,
        hideTitleonPrint: false,
        backup: {
          sageIDDelivery: ''
        },
        datalist: {
          pickup: '',
          pickupUid: '',
          delivery: '',
          deliveryUid: '',
          billing: '',
          billingUid: ''
        },
        fields: {
          numRef: '',
          vin: '',
          source: '',
          creationDate: '',
          receiverAddress: '',
          transmitterAddress: '',
          payerAddress: ''
        },
        suggestedPrice: 0,
        modal: {
          openPrice: false
        },
        order: {
          comment: '',
          latitude: 0.001,
          longitude: 0.001,
          make: '',
          model: '',
          datePromis: '',
          dateExpected: '',
          nbDispatch: 0,
          numRef: '',
          payer: '',
          payerAddress: '',
          payerCity: '',
          payerContact: '',
          payerFax: '',
          payerName: '',
          payerPhone: '',
          payerEmail: '',
          payerPostcode: '',
          payerCountry: '',
          payerProvince: '',
          receiver: '',
          receiverAddress: '',
          receiverCity: '',
          receiverContact: '',
          receiverFax: '',
          receiverName: '',
          receiverPhone: '',
          receiverEmail: '',
          receiverPostcode: '',
          receiverCountry: '',
          receiverProvince: '',
          status: 'Drop',
          source: '',
          transmitter: '',
          transmitterAddress: '',
          transmitterCity: '',
          transmitterContact: '',
          transmitterFax: '',
          transmitterName: '',
          transmitterPhone: '',
          transmitterEmail: '',
          transmitterPostcode: '',
          transmitterCountry: '',
          transmitterProvince: '',
          transpCigle: '',
          transpName: '',
          vin: '',
          year: '',
          regularPrice: 0,
          price: 0,
          discount: 0,
          surplus: 0
        },
        customers_fields: {
        'Order': 'order',
        'Ref': 'numRef',
        'Source': 'source',
        'VIN': 'vin',
        'Date': {
          field: 'creationDate',
          callback: (value) => {
            return this.getDate(value)
          }
        },
        'Pick': 'transmitterName',
        'Drop': 'receiverName',
        'Billing': 'payerName',
        'Status': 'status',
        'Driver': 'driverName',
        'Province pick': 'provincePick',
        'Province drop': 'provinceDrop',
        'Remark': 'comment'
      },
      billingFields: { // For accounts that are not sageOne/sageID
        'Order': 'Order',
        'Ref': 'Ref',
        'Item': 'Item',
        'Date': 'Date',
        'Price': 'Price',
        'Description': 'Description',
        'Billing': 'Billing',
        'ToBeEmailed': 'ToBeEmailed',
        'Driver': 'Driver',
        'Tax': 'Tax'
      },
        fieldsObj: [
        {
            text: `<i class="fa fa-solid fa-clipboard" />`,
            mobileText: this.$t('OrderCurrent.survey'),
            type: 'survey',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.order'),
            type: '.key',
            value: ''
        },
        // {
        //     text: this.$t('OrderCurrent.reference'),
        //     type: 'numRef',
        //     value: ''
        // },
        {
            text: this.$t('OrderCurrent.VIN'),
            type: 'vin',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.pickup'),
            type: 'transmitterName',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.delivery'),
            type: 'receiverName',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.billing'),
            type: 'payerName',
            value: ''
        },
        {
            text: this.$t('OrderCurrent.status'),
            type: 'status',
            value: ''
        },
        {
         text: '',
         type: '',
         value: ''
       }
        ],
        fieldsObjBIL: [
       {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.payer'),
         type: 'payerName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.sageID'),
         type: 'sageID',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.price'),
         type: 'price',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.fuel_charge'),
         type: 'fuelCharge',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.taxes'),
         type: 'taxes',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.taxescomment'),
         type: 'taxesComment',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.billingDate'),
         type: 'billingDate',
         value: ''
       }],
      fieldsObjEDI: [
        {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
        },
        {
         text: this.$t('OrderCurrent.source'),
         type: 'source',
         value: ''
        },
        {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
        },
        {
         text: this.$t('OrderCurrent.reason'),
         type: 'note',
         value: ''
        }
      ],
      fieldsObjVIN: [
      {
         text: this.$t('OrderCurrent.order'),
         type: '.key',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.VIN'),
         type: 'vin',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.modal.carInfo.make'),
         type: 'make',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.modal.carInfo.model'),
         type: 'model',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.modal.carInfo.year'),
         type: 'model',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.pickup'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.delivery'),
         type: 'receiverName',
         value: ''
       }
      ],
        buttonList: {
          heavy: {
            id: 4,
            label: this.$t('OrderCurrent.modal.heavy'),
            value: 'Heavy',
            selected: false,
            selectedBgColor: 'rgb(255, 178, 84, 30)'
          },
          medium: {
            id: 3,
            label: this.$t('OrderCurrent.modal.medium'),
            value: 'Medium',
            selected: false,
            selectedBgColor: 'rgb(255, 178, 84, 30)'
          },
          light: {
            id: 2,
            label: this.$t('OrderCurrent.modal.light'),
            value: 'Light',
            selected: false,
            selectedBgColor: 'rgb(255, 178, 84, 30)'
          },
          noSize: {
            id: 1, // If you change this id, also change it in @function setVehicleSize
            label: this.$t('OrderCurrent.modal.nosize'),
            value: 'No Size',
            selected: true,
            selectedBgColor: 'rgb(255, 178, 84, 30)'
          }
        },
        selectedOrderFilter: 'verify',
        orderFilterOptions: [
          { label: `${this.$t('OrderCurrent.sidebar.pending')}`, value: 'pending', route: '/OrderPending' },
          { label: this.$t('OrderCurrent.sidebar.current'), value: 'in_progress', route: '/OrderCurrent' },
          { label: this.$t('OrderCurrent.sidebar.delivered'), value: 'delivered', route: '/OrderDelivered' },
          { label: this.$t('OrderCurrent.sidebar.date'), value: 'date', route: '/OrderCurrent?newDate=true' }
        ],
        isLoading: true
      }
    },
  
    created () {
        this.isLoading = true
        this.$store.state.isSidebarOpen = false
        this.isScreenSmall = window.innerWidth < 800
        var id = this.companyUID

        // this.$bindAsArray(
        //     'delivered',
        //     db.ref('database/transporter/' + id + '/toVerify/'),
        //     null,
        //     () => {
        //         this.isLoading = false
        //     }
        // )
        this.$bindAsArray(
            'allDeliveries',
            db.ref('database/transporter/' + id + '/deliveries/'),
            null,
            () => {
            this.isLoading = false
            }
        )
    },

    methods: {
      handleFilterButtonClick (buttonName) {
        this.activeButton = buttonName
        const selectedOption = this.orderFilterOptions.find(option => option.value === buttonName)
        if (selectedOption && selectedOption.route) {
          this.$router.push(selectedOption.route)
        }
      },
      handleToggle (route) {
        this.$router.push(`/${route}`)
      },
    async approveAction (order) {
        try {
            this.isLoading = true

            const orderNumber = order['.key']
            const verificationStatus = order.status // "to cancel" or "to finish"
            const finalStatus = verificationStatus === 'to cancel' ? 'Cancel' : 'Terminée'

            const deliveriesRef = db.ref(`database/transporter/${this.companyUID}/deliveries/${orderNumber}/status`)
            await deliveriesRef.set(finalStatus)

            // Log the approval action
            await this.$store.dispatch('newLog', {
                'UID': this.uid,
                'orderID': orderNumber,
                'action': finalStatus === 'Cancel' ? 'APPROVE_CANCEL' : 'APPROVE_FINISH',
                'status': finalStatus,
                'date': Date.now()
            })

            // Sync with external system if needed
            publishOrderSyncRequest(orderNumber, this.companyUID)

            this.isLoading = false
        } catch (error) {
            console.error(`Error approving order:`, error)
            this.isLoading = false
        }
    },
    denyAction (order) {
        order.orderNumber = order['.key']
        this.selectedFull.push(order)
        this.isStatusEdit = true
    },
      onOrderFilterSelect (value) {
        this.selectedOrderFilter = value
        const selectedOption = this.orderFilterOptions.find(option => option.value === value)
  
        if (selectedOption && selectedOption.route) {
          this.$router.push(selectedOption.route)
        }
      },
     async openPrice (order) {
        this.modal.openPrice = true
        order.datePromis = ''
        this.selectedOrder = {...order}
        this.suggestedPrice = this.selectedOrder.price
        this.selectedOrder.price = 0
  
        await this.getVehicleSize(this.returnMakeModel)
        this.setVehicleSize(this.SIZE)
      },
      updateDatePick (date) {
        date = this.formatDate(date)
        this.spreadDate = date
      },
      applyBillingDateToAll (date) {
        this.selectedFull.forEach((element) => {
          element.billingDate = date
        })
      },
      setPriceOrderLink (element, orderInfo) {
        let priceObj = {
          orderId: element,
          price: orderInfo.price,
          orderInfo: orderInfo
        }

        this.priceOrderLink.push(priceObj)
      },
      checkHistorySyncDrops (historysync) {
        let dropFlag = true
        for (const key in historysync) {
          console.log(key, historysync[key].dropDate)
          if (!historysync[key].dropDate) {
            dropFlag = false
            break
          }
        }
        return dropFlag
      },
      async getVehicleSize (makeModel) {
        await db.ref(`vehicleSize/${this.companyUID}/${makeModel}`).once('value').then((snapshot) => {
          this.SIZE = snapshot.val()
          this.setSizeTooltipText(true)
        }).catch(() => {
          this.SIZE = '1'
          this.setSizeTooltipText(false)
          console.log('No vehicle size')
        })
      },
      openBilling (isOdooBill = false) {
        this.isOdooBill = isOdooBill
        this.fetchSelected('BILLING')

        this.billing = true
      },
      openStatusEdit () {
        this.isStatusEdit = true
      },
      fetchSelected (action) {
        this.selectedFull = []
        this.selectedFull2 = []
        this.priceOrderLink = []

        let selectedReversed = [...this.selected]
        selectedReversed.reverse()

        selectedReversed.forEach((orderId) => {
          db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).once('value').then((snap) => {
            const selectedFull = this.selectedFull
            const selectedFull2 = this.selectedFull2
            let orderData = snap
            this.setDataFromFetch(selectedFull, selectedFull2, orderData)

            if (action === 'BILLING') this.setFuelCharge()
            if (action === 'DISPATCH' || (action === 'BILLING' && !orderData.val().price)) {
              // this.$set(selectedFull[selectedFull.length - 1], 'price', '') // Why?
              if (action === 'DISPATCH') {
                this.setPriceOrderLink(orderId, orderData.val())
                this.$set(selectedFull[selectedFull.length - 1], 'comment', 'Client/Customer: ' + orderData.val().payerName)
                if (this.userInfo.driverComment) selectedFull[selectedFull.length - 1].comment += '\n' + orderData.val().comment
              }
            }

            if (!orderData.val().taxes) this.$set(selectedFull[selectedFull.length - 1], 'taxes', '')
            if (!orderData.val().taxesComment) this.$set(selectedFull[selectedFull.length - 1], 'taxesComment', '')
            if (!orderData.val().transmitterCountry) this.$set(selectedFull[selectedFull.length - 1], 'transmitterCountry', '')
            if (!orderData.val().receiverCountry) this.$set(selectedFull[selectedFull.length - 1], 'receiverCountry', '')
            if (!orderData.val().billingDate) this.$set(selectedFull[selectedFull.length - 1], 'billingDate', this.formatDate(Date.now()))
            this.$set(selectedFull[selectedFull.length - 1], 'isReady', true)
            this.order = JSON.parse(JSON.stringify(selectedFull[0]))
          })
        })
      },
      setFuelCharge () {
        this.selectedFull.forEach(element => {
          let fuelCharge = element.fuelCharge
          if (element.includedFuelCharge || element.applyFuelCharge === false) {
            this.$set(element, 'includedFuelCharge', true)
            this.$set(element, 'applyFuelCharge', false)
          }
          if (fuelCharge === undefined || fuelCharge === null || fuelCharge === '') element.fuelCharge = this.$store.state.userInfo.fuelCharge || 0
          else console.log('Elsed', this.$store.state.userInfo.fuelCharge)
        })
      },
      formatDate (date) {
        let fdate = new Date(date)
        fdate = fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)

        return fdate
      },

    setDataFromFetch (selectedFull, selectedFull2, orderData) {
      this.$set(selectedFull, selectedFull.length, orderData.val())
      this.$set(selectedFull[selectedFull.length - 1], 'orderNumber', orderData.key) // Used in other functions, be careful changing the 'orderNumber' variable name

      this.$set(selectedFull[selectedFull.length - 1], 'billOrderNumber', 'QB' + orderData.key) // For billingFields excel sheet generation
      this.$set(selectedFull[selectedFull.length - 1], 'fromToBilling', orderData.val().make + ' ' + orderData.val().model + ' ' + orderData.val().year + ' - VIN: ' + orderData.val().vin + ' ' + orderData.val().transmitterName + ' to ' + orderData.val().receiverName)

      const obj = { // For accounts that are not sageOne/sageID
        'Order': 'QB' + orderData.key,
        'Item': 'Sales',
        'Ref': orderData.val().numRef,
        'Date': orderData.val().billingDate,
        'Price': orderData.val().price,
        'Description': orderData.val().make + ' ' + orderData.val().model + ' ' + orderData.val().year + ' - VIN: ' + orderData.val().vin + ' ' + orderData.val().transmitterName + ' to ' + orderData.val().receiverName + ' Shipped to : ' + orderData.val().receiverProvince,
        'Billing': orderData.val().payerName,
        'Driver': orderData.val().driverName,
        'ToBeEmailed': true,
        'Tax': 'H'
      }
      const orderFuelCharge = orderData.val().fuelCharge
      const fuelChargePercent = orderFuelCharge !== undefined && orderFuelCharge !== null && orderFuelCharge !== ''
        ? orderFuelCharge
        : this.$store.state.userInfo.fuelCharge || 0
      const fuelChargeAmount = (orderData.val().includedFuelCharge || orderData.val().applyFuelCharge === false)
        ? 0
        : (Number(orderData.val().price) * Number(fuelChargePercent)) / 100

      const obj2 = { // For accounts that are not sageOne/sageID
        'Order': 'QB' + orderData.key,
        'Ref': orderData.val().numRef,
        'Item': 'Fuel Surcharge',
        'Date': orderData.val().billingDate,
        'Price': fuelChargeAmount,
        'Description': fuelChargePercent + '%',
        'Billing': orderData.val().payerName,
        'Driver': ' ',
        'ToBeEmailed': true,
        'Tax': 'H'
      }

      this.$set(selectedFull2, selectedFull2.length, obj)
      this.$set(selectedFull2, selectedFull2.length, obj2)
    },
      openEditOrderModal (order) {
        this.selectedOrder = {...order}
        this.isEditOrderModal = true
      },
      async setVehiclePrice (size) {
        const postcodePath = this.returnPostcodePath
        let dbPath = ''
  
        if (this.isBillingWholesaleExpress) dbPath = `vehiclePrice/wholesale/${postcodePath}/${size}`
        else dbPath = `vehiclePrice/${this.companyUID}/${postcodePath}/${size}`
        await db.ref(dbPath).once('value').then((snapshot) => {
          this.selectedOrder.regularPrice = parseInt(snapshot.val().regularPrice) || 0
          this.selectedOrder.surplus = parseInt(snapshot.val().tax) || 0
          this.selectedOrder.discount = parseInt(snapshot.val().discount) || 0
          this.setPriceTooltipText(true, this.selectedOrder.regularPrice, this.selectedOrder.surplus, this.selectedOrder.discount)
          this.calculateCarPrice()
        }).catch(() => {
          this.setPriceTooltipText(false)
          this.selectedOrder.regularPrice = 0
          this.selectedOrder.surplus = 0
          this.selectedOrder.discount = 0
          this.calculateCarPrice()
        })
      },
      shortenString (text) {
        if (typeof text === 'undefined') return text
        else {
            let subString = text.substring(0, 22)
            if (text.length > 22) subString += '...'
            return subString
        }
       },
       lastHistorySync (obj, key) {
            const lastKey = Object.keys(obj)
                .sort((a, b) => {
                const numA = parseInt(a.split('-')[1], 10)
                const numB = parseInt(b.split('-')[1], 10)
                return numA - numB
                })
                .pop()
            if (lastKey && obj[lastKey] && obj[lastKey][key]) {
                return obj[lastKey][key]
            } else {
                return null
            }
        },

      async setVehicleSize (size) {
        const keys = Object.keys(this.buttonList)
  
        if (!size) {
          let selectedSize = keys.find(key => this.buttonList[key].id.toString() === '1') // 1 is the id of "no size" in buttonList
          this.$refs.toggleSwitch.onOptionSelect(this.buttonList[selectedSize])
        } else {
          let selectedSize = keys.find(key => this.buttonList[key].id.toString() === size.toString())
          this.$refs.toggleSwitch.onOptionSelect(this.buttonList[selectedSize])
        }
      },
  
      setSizeTooltipText (isTruthy) {
        if (isTruthy) {
          this.sizeTooltipText = `${this.$t('Vehicle.size_found')} (${this.getStringVehicleSize(this.SIZE)})`
          this.sizeTooltipColor = 'green'
        } else {
          this.sizeTooltipText = this.$t('Vehicle.size_not_found')
          this.sizeTooltipColor = 'red'
        }
      },
  
      getStringVehicleSize (size = '1') {
        let text = ''
        const keys = Object.keys(this.buttonList)
  
        text = keys.find(key => this.buttonList[key].id.toString() === size.toString())
        text = this.buttonList[text].label
  
        return text
      },
  
      setPriceTooltipText (isTruthy, regularPrice, discount, surplus) {
        if (isTruthy) {
          this.priceTooltipText = `${this.$t('Vehicle.price_found')} (P:${regularPrice}$, ${this.$t('Vehicle.discount_shorthand')}:${discount}%, S:${surplus}%)`
          this.priceTooltipColor = 'green'
        } else {
          this.priceTooltipText = this.$t('Vehicle.price_not_found')
          this.priceTooltipColor = 'red'
        }
      },
  
      updateMakeModelFirebase (vehicleSizeId) {
        db.ref(`vehicleSize/${this.companyUID}/${this.returnMakeModel}`).set(vehicleSizeId)
      },
  
      updateFilterResults (sortResults) {
        this.filterResults = sortResults
      },
      validatePricing: function (names) {
        window.axios.get(`${process.env.API_ENDPOINT}/decode/pad/pricing/e58ff614-8449-4c3e-90b8-b42a48c2972b/` + names).then((response) => {
          this.pricingAndDelay = response.data
        }).catch((error) => console.log(error))
      },
  
      // Called on key events when typing a price in the Add New Order modal
      calculateCarPrice (keyEvent) {
        const discountAmount = ((Number(this.selectedOrder.regularPrice) * Number(this.selectedOrder.discount)) / 100)
        const surplusAmount = ((Number(this.selectedOrder.regularPrice) - discountAmount) * Number(this.selectedOrder.surplus) / 100)
        this.selectedOrder.price = ((Number(this.selectedOrder.regularPrice) - discountAmount) + surplusAmount).toFixed(2)
  
        this.verifyPriceValues()
      },
  
      verifyPriceValues () {
        if (this.selectedOrder.regularPrice <= 0) {
          this.selectedOrder.regularPrice = 0
        }
  
        if (this.selectedOrder.discount <= 0) {
          this.selectedOrder.discount = 0
        }
  
        if (this.selectedOrder.surplus <= 0) {
          this.selectedOrder.surplus = 0
        }
  
        if (this.selectedOrder.price <= 0) {
          this.selectedOrder.price = 0
        }
      },

    setNoteName (user) {
      const isFirstNameValid = (typeof user.firstName !== 'undefined' && user.firstName !== '')
      const isLastNameValid = (typeof user.lastName !== 'undefined' && user.lastName !== '')

      if (!isFirstNameValid || !isLastNameValid) return this.$store.state.userInfo.name
      else return `${user.firstName} ${user.lastName}`
    },
      clearSelected () {
        this.selected = []
      },
      clearfeedbackMessage () {
        this.feedbackMessage = ''
      },
      clear: function () {
        for (let attr in this.order) {
          this.order[attr] = ''
        }
        this.clearfeedbackMessage()
        this.dispatchOrder.chauffeur = ''
        this.dispatchOrder.chauffeurName = ''
        this.order.regularPrice = 0
        this.order.price = 0
        this.order.discount = 0
        this.order.surplus = 0
        this.order.status = 'Processing'
        this.order.latitude = 0.001
        this.order.longitude = 0.001
        this.order.nbDispatch = 0
        for (let attr in this.datalist) {
          this.datalist[attr] = ''
        }
        this.vehicles = []
        this.VIN = ''
        this.MAKE = ''
        this.MODEL = ''
        this.YEAR = ''
        this.SIZE = null // Car size check
        this.badVin = false // Valid vin check
      },
      getDate: function (timestamp) {
        var date = new Date(timestamp)
        return date.toLocaleDateString()
      },

      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50)
    },
  
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
      db.ref('users/transporters').child(this.companyUID).once('value').then((snapshot) => {
        this.$store.commit('setUserInfo', snapshot.val() || false)
        this.user = snapshot.val()
      })
    },
  
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
  
    computed: {
      // WholesaleExpress has a whole different pricing compared to others so we want to save their data in a different node
      isBillingWholesaleExpress () {
        return (this.selectedOrder.payer === '57aa460a-e2e6-4d83-8832-ca4546d6149c')
      },
      delivered () {
            return this.allDeliveries.filter(order =>
                isRegularOrder(order) && (order.status === 'to cancel' || order.status === 'to finish')
                )
        },
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      fuelChargeProxy: {
        get () {
          return this.order.applyFuelCharge === false ? 0 : this.order.fuelCharge
        },
        set (value) {
          if (value !== '') {
            this.$set(this.order, 'includedFuelCharge', false)
            this.$set(this.order, 'applyFuelCharge', true)
          }
          this.order.fuelCharge = value
        }
      },
      allOrderID () {
        var orderIDs = ''
        this.selected.forEach((element, index) => {
          index !== 0 ? orderIDs += '+' + element : orderIDs += element
        })
        return orderIDs
      },
      hasFullAccess () {
        return this.$store.state.userInfo.userType === 'full'
      },
      isOdooBillingEnabled () {
        return this.$store.state.userInfo.featureFlags && this.$store.state.userInfo.featureFlags.odooBilling
      },
      isDateRoute () {
        return this.$route.query.newDate
      },
  
      // TODO: Check for invalid postal codes that contain special characters Ex: VIN - 2HGFC3B31GH427642
      returnPostcodePath () {
        if (this.selectedOrder.transmitterPostcode === '' || this.selectedOrder.receiverPostcode === '') console.log('Empty postcodes', this.selectedOrder.transmitterPostcode, this.selectedOrder.receiverPostcode)
        const transmitterPostcode = this.selectedOrder.transmitterPostcode || 'NoTransmitter'
        const receiverPostcode = this.selectedOrder.receiverPostcode || 'NoReceiver'
        let path = ''
  
        path = transmitterPostcode.toLowerCase() + receiverPostcode.toLowerCase()
        path = path.split(' ').join('')
  
        return path
      },
      allBillingFieldCompleted () {
        var result = true

        this.selectedFull.forEach((element) => {
          if (element.taxes === '' || element.price === '' || element.taxes === undefined || element.price === undefined || element.sageID === '' || element.sageID === undefined) result = false
        })

        return result
      },

      returnMakeModel () {
        if (this.checkIsUndefined(this.selectedOrder.make)) this.selectedOrder.make = ''
        if (this.checkIsUndefined(this.selectedOrder.model)) this.selectedOrder.model = ''
  
        const make = this.selectedOrder.make.toLowerCase()
        const model = this.selectedOrder.model.toLowerCase()
        let makeModel = make.split(' ').join('') + model.split(' ').join('')
  
        makeModel = makeModel.replace('.', '')
        makeModel = makeModel.replace('$', '')
        makeModel = makeModel.replace('#', '')
        makeModel = makeModel.replace('[', '')
        makeModel = makeModel.replace(']', '')
  
        if (makeModel.length <= 0) makeModel = 'NoMakeModel'
        return makeModel
      },
      isSageOne () {
        return this.$store.state.userInfo.isSageOne
      },
      sageOneCheck () {
        return ((this.$store.state.userInfo.isSageOne && this.order.sageID !== '' && this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne)
      },
      isQuickBook () {
        return this.$store.state.userInfo.isQuickbook
      },
      companyUID () {
        return this.$store.state.authorization.company
      },
  
      uid () {
        return this.$store.state.user.uid
      }
    }
  }
  </script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #suggested_price {
    background-color: #dfdfdf;
    border-radius: 3px;
    }
    .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
    }
    #action{
    display: flex;
    justify-content: end;
    min-width: 110px;
    }
    .kne-tab.active{
    color: #f7941e !important;
    }
    .kne-tab:hover{
    color: #f7941e !important;
    }
    .view{
    padding-left: 10.5rem;
    }

    .flexContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    }
    .mobileFlexContainer {
    flex-direction: column;
    }
    .addressContainer {
    width: 50%;
    }

    .carInfoContainer {
    width: 25%;
    }

    .miscContainer {
    display:flex;
    flex-direction: column;
    align-content: flex-end;
    width: 25%;
    }

    label {
    margin-left: 1rem;
    }

    .toggleSwitch {
    display: flex;
    flex-direction: row;
    justify-content: center;
    }

    .toggle-button-group button {
        border: 1px solid transparent;
        padding: 6px 16px;
        cursor: pointer;
        outline: none;
        background:white;
        border-left:1px solid rgba(201, 192, 192, .4);
        border-right: 1px solid rgba(201, 192, 192, .4);
    }

    .toggle-button-group button.active {
        background-color: #f7941e;
        color: white;
        border:1px solid transparent;
    }
</style>
